import { IMilestoneCountResponseOK, milestoneCount } from '@ifit/gateway-lumberjack';
import { useQuery, UseQueryResult } from 'react-query';
import { FIFTEEN_SECONDS, ONE_DAY } from '../../util/durations';
import { useLanguage } from '../selectors/use-language';
import { useToken } from '../selectors/use-token';
import { useUserId } from '../selectors/use-user-id';

export function useMilestoneCount(year: number): UseQueryResult<IMilestoneCountResponseOK, Error> {
  const token = useToken();
  const userId = useUserId();
  const language = useLanguage();

  return useQuery<IMilestoneCountResponseOK, Error>(
    ['user-milestone-count', { userId, year, language }],
    () => milestoneCount({ year, userId }).then((x) => x),
    { staleTime: FIFTEEN_SECONDS, cacheTime: ONE_DAY, enabled: Boolean(token) }
  );
}
